"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAcceptance = void 0;

class TermsAcceptance {
  /**
   * @description TermsAcceptance constructor
   * @param needsAcceptance Acceptance data
   * @param templateName Terms template name
   * @param templateRevisionContentId Revision content ID for the current terms
   * @param templateRevision Revision ID for the current terms
   */
  constructor(options) {
    Object.assign(this, options);
  }
  /**
   * @description Check if the current terms need to be accepted
   * @returns true if the current terms need to be accepted.
   * false otherwise, including missing terms.
   */


  needToAcceptTerms() {
    var _a;

    return !!((_a = this.needsAcceptance) === null || _a === void 0 ? void 0 : _a.needed);
  }
  /**
   * @description Find the terms content for a specific locale, e.g. en_US.
   * @param locale Locale string, e.g. en_US. The list of available locales
   * are specified in CLAM (with JIL as a passthrough service)
   * @returns TermsContent if the locale is found. undefined otherwise.
   */


  findTermsContent(locale) {
    var _a;

    return (_a = this.needsAcceptance.templateDetails) === null || _a === void 0 ? void 0 : _a.contents.find(content => content.locale === locale);
  }

}

exports.TermsAcceptance = TermsAcceptance;